var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('code-login',{ref:"myCodeLogin",on:{"update-page":_vm.updatePage}}),_c('head-top',{attrs:{"head-title":"直播课程","goBack":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }